<template>
  <div
    v-if="!loading && images.length"
    id="systemExampleImageCarousel"
    :class="styleClass"
    @click="setImageIndex"
  >
    <div class="carousel-inner">
      <div
        v-for="(image, index) in images"
        :key="slideKey(image, index)"
        class="carousel-item"
        :class="{ active: index === 0 }"
      >
        <div class="row g-2 px-1">
          <div v-for="(i, idx) in image" :key="i.path || idx" class="col">
            <a
              class="configurator__carousel-i"
              data-bs-toggle="modal"
              href="#systemExampleImageModal"
            >
              <img
                :src="$filters.image(i.path)"
                class="configurator__carousel-img"
                :data-image-id="i.path"
              >
            </a>
          </div>
        </div>
      </div>
    </div>
    <a
      class="carousel-control-prev bg-transparent"
      href="#systemExampleImageCarousel"
      role="button"
      data-bs-slide="prev"
    >
      <i class="fas fa-chevron-left"></i>
    </a>
    <a
      class="carousel-control-next bg-transparent"
      href="#systemExampleImageCarousel"
      role="button"
      data-bs-slide="next"
    >
      <i class="fas fa-chevron-right"></i>
    </a>
  </div>
</template>
<script>
import { computed } from '@vue/reactivity'
import { useStore } from 'vuex'
import _ from 'lodash'

export default {
  name: 'SystemCarousel',
  props: {
    styleClass: {
      type: String,
      default: 'carousel slide configurator__carousel'
    }
  },
  setup () {
    const store = useStore()

    const images = computed(() => {
      const imgs = store.getters['system/exampleImages'] || []
      const result = _.orderBy(imgs, ['sort'], ['asc'])
      const limit = 4
      const arr = []
      for (let i = 0; i < result.length; i += limit) {
        arr.push(result.slice(i, i + limit))
      }
      return arr
    })

    const loading = computed(() => store.getters['system/exampleImagesLoading'])

    function setImageIndex (e) {
      const index = e.target?.dataset?.imageId
      if (index) {
        store.commit('system/SET_EXAMPLE_IMAGE_INDEX', index)
      }
    }

    function slideKey (image, index) {
      const paths = (image || []).map(item => item.path).join('|')
      return `${index}-${paths}`
    }

    return {
      images,
      loading,
      setImageIndex,
      slideKey
    }
  }
}
</script>
<style scoped>
.carousel-item {
  transition: transform 0.2s ease-in-out;
}

.configurator__carousel-i {
  display: block;
  padding: 0 6px;
}

.configurator__carousel-img {
  display: block;
  width: 100%;
  height: 75px;
  object-fit: cover;
  margin: 0;
}
</style>
